import type { ClientResource } from '@/features/Clients';
import type { MappingKeys } from '@/features/Clients/ClientMapper/clientMapper';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';
import { ClientResourcePWApi } from '@/features/Clients';

export class ClientHttpService extends HttpService {
  loadClientById(id: string | number): HttpClientResponse<ClientResource> {
    return this.httpClient.get(`kunde/${id}`);
  }

  searchClientByName(query: string): HttpClientResponse<ClientResourcePWApi[]> {
    return this.httpClient.get('kunde/search/by-name', {
      params: {
        query,
      },
    });
  }

  saveClient(
    client: Record<MappingKeys, unknown>,
    id: number | null,
  ): HttpClientResponse<{ id: number }> {
    if (id !== null) {
      return this.httpClient.put(`kunde/${id}`, {
        data: client,
      });
    }
    return this.httpClient.post('kunde', {
      data: client,
    });
  }
}
